import { IFeature } from 'mod/featureV2/interface';

const width = 3840;
const height = 1860;

export const anchorsBanner: IFeature = {
    type: 'anchorsBanner',
    moduleId: 'anchorsBanner',
    title: 'anchorsBanner',
    description: 'description',
    config: {
        width,
        height,
        bgColor: '#c9d9ce',
        type: 'grid',
        grid: {
            column: 2,
            gutter: 20
        }
    },
    list: [
        {
            src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
            alt: 'test',
            href: '/vivosun-smart-grow-box?mock=1',
            anchors: [
                {
                    x: width / 4,
                    y: height / 4,
                    clickType: 'QUICK_VIEW',
                    variantId: '58820960379616584'
                },
                {
                    x: width / 2,
                    y: height / 2,
                    clickType: 'QUICK_VIEW',
                    variantId: '58820960379609764'
                },
            ]
        },
        {
            src: 'file-asset/file/6a850710f4ee9020a478fa0caff005dc.mp4',
            anchors: [
                {
                    x: width / 5,
                    y: height / 5,
                    clickType: 'BUBBLE',
                    bubble: {
                        placement: 'right',
                        tip: 'Hassle-free setup',
                        button: {
                            text: 'Explorer',
                            href: '/promotional-sale?mock=1',
                            type: 'base',
                            size: 'small',
                            shape: 'round',
                        },
                    }
                },
                {
                    x: width / 1.1,
                    y: height / 1.1,
                    clickType: 'BUBBLE',
                    bubble: {
                        placement: 'left',
                        tip: 'Hassle-free setup in minutes without tools Full-spectrum Led grow lights for horticulture with adjustable spectrum Patented multi-layer circulation',
                        button: {
                            text: 'Explorer',
                            href: '/promotional-sale?mock=1',
                            type: 'base',
                            size: 'small',
                            shape: 'round',
                        },
                    }
                },
            ]
        },
    ]
};

export const anchorsBanner2: IFeature = {
    type: 'anchorsBanner',
    moduleId: 'anchorsBanner',
    title: 'anchorsBanner',
    description: 'note',
    config: {
        width: 1920,
        height: 900,
        bgColor: '#525242',
    },
    list: [
        {
            src: 'asset/width-3840/picture/397ab75cd022e8bc7c652ac2eed5c323.jpg',
            alt: 'test',
            anchors: [
                {
                    x: 553,
                    y: 51,
                    clickType: 'NOTE',
                    note: {
                        title: 'Start',
                        description: 'Choose from multiple grow tent kit sizes and configurations to start growing with ease.',
                        button: {
                            text: 'Start With a Kit',
                            href: '/?mock=1',
                        },
                    }
                },
                {
                    x: 1404,
                    y: 253,
                    clickType: 'NOTE',
                    note: {
                        title: 'Start',
                        description: 'Choose from multiple grow tent kit sizes and configurations to start growing with ease.',
                        button: {
                            text: 'Start With a Kit',
                            href: '/?mock=1',
                        },
                        style: {
                            width: 200,
                            backgroundColor: 'rgba(0, 0, 0, .4)',
                            padding: 20,
                            borderRadius: 8
                        }
                    }
                },
                {
                    x: 213,
                    y: 347,
                    clickType: 'NOTE',
                    note: {
                        title: 'Start',
                        description: 'Choose from multiple grow tent kit sizes and configurations to start growing with ease.',
                        button: {
                            text: 'Start With a Kit',
                            href: '/?mock=1',
                        },
                        style: {
                            width: 200,
                            backgroundColor: 'rgba(255, 255, 255, .6)',
                            padding: 20,
                            borderRadius: 8
                        }
                    }
                },
            ]
        },
    ]
};

